const KEYWORDS = [
	"Rithvik",
	"Rithvik K",
	"AI Engineer",
	"Machine Learning",
	"Open Source",
	"Blockchain",
	"Portfolio",
];

const SEO = [
	{
		page: "home",
		description:
			"Rithvik K — AI/ML engineer, open-source mentor, and technical writer building RAG systems, AI chatbots, and Web3 apps.",
		keywords: KEYWORDS,
	},
	{
		page: "about",
		description:
			"Rithvik's open-source contributions, mentorship roles, community work, and tech talks.",
		keywords: KEYWORDS,
	},
	{
		page: "articles",
		description:
			"Long-form writing by Rithvik K on AI, machine learning, RAG, blockchain, and developer tooling.",
		keywords: KEYWORDS,
	},
	{
		page: "projects",
		description:
			"Projects by Rithvik K spanning AI, blockchain, IoT, and web development — most are open source.",
		keywords: KEYWORDS,
	},
	{
		page: "contact",
		description:
			"Get in touch with Rithvik K for collaborations, talks, mentorship, or opportunities.",
		keywords: KEYWORDS,
	},
];

export default SEO;
